<!--
  ctrBasMttCnf.vue ( 3-1 step, mblElcSgn02 )
  - 단건 계약정보사항 확인
 -->
<template>
  <div id="wrap" class="wrap_layout">
    <Header />
    <!--Container [s]-->
    <div class="container">
      <div class="contents">
        <!--Contents Area [s]-->
        <div class="section">
          <!-- 2021-08-02 : 수정 -->
          <p class="txt">
            언제나 메리츠화재를 사랑해 주셔서 감사드립니다.<br />해당 안내는
            <strong class="point">{{ state.yyyymmdd }}</strong> 요청하신
            안내입니다.
          </p>
          <!-- // 2021-08-02 : 수정 -->
          <p class="tit">진행단계</p>
          <ActiveAnimation root="ul" class="process_step">
            <li>
              <span class="tit_step">Step01</span>
              <p>계약 선택</p>
            </li>
            <li>
              <span class="tit_step">Step02</span>
              <p>계약기본사항 확인</p>
            </li>
            <li>
              <span class="tit_step">Step03</span>
              <p>전자서명</p>
            </li>
            <li>
              <span class="tit_step">Step04</span>
              <p>서명입력 및 주요사항확인</p>
            </li>
            <li>
              <span class="tit_step">Step05</span>
              <p>지문인증</p>
            </li>
            <li v-if="state.papeYn">
              <span class="tit_step">Step06</span>
              <p>완전판매모니터링</p>
            </li>
          </ActiveAnimation>
          <p class="tit_tbl">계약기본사항</p>
          <div class="data_table type_row data">
            <table>
              <caption class="blind">
                계약기본사항
              </caption>
              <colgroup>
                <col style="width: 85px" />
                <col />
              </colgroup>
              <tbody>
                <tr>
                  <th scope="row">상품명</th>
                  <td>{{ state.ctrBasInfCoVo.untPdNm }}</td>
                </tr>
                <tr>
                  <th scope="row">가계약번호</th>
                  <td>{{ state.ctrBasInfCoVo.prctrNo }}</td>
                </tr>
                <tr>
                  <th scope="row">계약자</th>
                  <td>{{ state.ctrBasInfCoVo.polhdNm }}</td>
                </tr>
                <tr v-if="state.rtrnAnimInsYn">
                  <th scope="row">반려동물명</th>
                  <td>{{ state.ctrBasInfCoVo.petNm }}</td>
                </tr>
                <tr v-else>
                  <th scope="row">피보험자</th>
                  <td>{{ state.ctrBasInfCoVo.maInspeNm }}</td>
                </tr>
                <tr>
                  <th scope="row">보험기간</th>
                  <td>
                    {{
                      dateFormat(state.ctrBasInfCoVo.insBgnDt) +
                      " ~ " +
                      dateFormat(state.ctrBasInfCoVo.insEdDt)
                    }}
                  </td>
                </tr>
                <tr
                  v-if="
                    state.ctrBasInfCoVo.dthErnpeNm != null &&
                    state.ctrBasInfCoVo.dthErnpeNm != ''
                  "
                >
                  <th scope="row">사망수익자</th>
                  <td>{{ state.ctrBasInfCoVo.dthErnpeNm }}</td>
                </tr>
                <tr
                  v-if="
                    state.ctrBasInfCoVo.etcErnpeNm != null &&
                    state.ctrBasInfCoVo.etcErnpeNm != ''
                  "
                >
                  <th scope="row">기타수익자</th>
                  <td>{{ state.ctrBasInfCoVo.etcErnpeNm }}</td>
                </tr>
                <tr
                  v-if="
                    state.ctrBasInfCoVo.exprErnpeNm != null &&
                    state.ctrBasInfCoVo.exprErnpeNm != ''
                  "
                >
                  <th scope="row">만기수익자</th>
                  <td>{{ state.ctrBasInfCoVo.exprErnpeNm }}</td>
                </tr>
                <tr
                  v-if="
                    state.ctrBasInfCoVo.appnSroClmpeNm != null &&
                    state.ctrBasInfCoVo.appnSroClmpeNm != ''
                  "
                >
                  <th scope="row">지정대리청구인</th>
                  <td>{{ state.ctrBasInfCoVo.appnSroClmpeNm }}</td>
                </tr>
                <tr
                  v-if="
                    state.ctrBasInfCoVo.appnSroClmpeNm1 != null &&
                    state.ctrBasInfCoVo.appnSroClmpeNm1 != ''
                  "
                >
                  <th scope="row">지정대리청구인</th>
                  <td>{{ state.ctrBasInfCoVo.appnSroClmpeNm1 }}</td>
                </tr>
                <tr v-if="state.dporInclYn != null && state.dporInclYn == 'Y'">
                  <th scope="row">예금주</th>
                  <td>{{ state.ctrBasInfCoVo.dporNm }}</td>
                </tr>
                <tr v-if="state.ctrBasInfCoVo.bthAftSlzPrem == 0">
                  <th scope="row">보험료</th>
                  <td>
                    <strong class="point02"
                      >{{ numberFormat(state.ctrBasInfCoVo.slzPrem) }}원</strong
                    >
                  </td>
                </tr>
                <tr v-if="state.ctrBasInfCoVo.bthAftSlzPrem > 0">
                  <th scope="row">보험료</th>
                  <td>
                    출생전
                    <strong class="point02"
                      >{{ numberFormat(state.ctrBasInfCoVo.slzPrem) }}원</strong
                    >
                    출생후
                    <strong class="point02"
                      >{{
                        numberFormat(state.ctrBasInfCoVo.bthAftSlzPrem)
                      }}원</strong
                    >
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="btn_area masterBtn">
            <button type="button" class="btn_main" @click="confirm">
              <span>전자서명 시작하기</span>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { reactive, onMounted, inject } from "vue";
import { useStore } from "vuex";
import { useRouter } from "vue-router";
import util from "@/common/util";
import { sessionUserInfo, load } from "@/common/sessionFactory";
import useDialog from "@/common/dialog";
import Header from "@/components/common/Header.vue";
import ActiveAnimation from "@/components/common/ActiveAnimation.vue";
import { enableScroll } from "@/common/scrnCtrl";

export default {
  name: "ctrBasMttCnf",
  components: {
    Header,
    ActiveAnimation,
  },
  setup() {
    const router = useRouter();
    const axios = inject("axios");
    const store = useStore();
    const dialog = useDialog(inject("$vfm"));

    const state = reactive({
      currDate: util.formatDate(new Date(), "yyyymmdd"),
      yyyymmdd: util.formatDate(new Date(), "yyyy년 mm월 dd일"),
      ctrBasInfCoVo: {},
      dporInclYn: "",
      papeYn : true,
    });

    const variables = {
      cfntDscMd: "",
      cfntDscPlc: "",
      inspeCfntDscMd: "",
      inspeCfntDscPlc: "",
      
    };

    enableScroll();

    onMounted(async () => {
      await load();

      if (util.isEmpty(sessionUserInfo) || util.isNull(sessionUserInfo)) {
        router.push({ name: "sessionExpired" });
        return;
      }

      let cfntDscMdCd = sessionUserInfo.cfntDscMdCd;
      let cfntDscPlcCd = sessionUserInfo.cfntDscPlcCd;
      let cfntDtm = sessionUserInfo.cfntDtm;
      let inspeCfntDscMdCd = sessionUserInfo.inspeCfntDscMdCd;
      let inspeCfntDscPlcCd = sessionUserInfo.inspeCfntDscPlcCd;
      let inspeCfntDtm = sessionUserInfo.inspeCfntDtm;

      if (
        _.isEmpty(cfntDscMdCd) ||
        _.isEmpty(cfntDscPlcCd) ||
        _.isEmpty(cfntDtm) ||
        _.isEmpty(inspeCfntDscMdCd) ||
        _.isEmpty(inspeCfntDscPlcCd) ||
        _.isEmpty(inspeCfntDtm)
      ) {
        dialog
          .alert(
            "대면정보가 누락되었습니다. 마지막으로 수신한 알림톡으로 접속해주시기 바랍니다."
          )
          .then(() => {
            router.push({ name: "sessionExpired" });
          });
        return;
      }

      let res = await Promise.all([
        retrieveDmnInf("202003250005"),
        retrieveDmnInf("202003260001"),
      ]);

      let cdsExplain = res[0].data.row;
      let cdsPlace = res[1].data.row;

      let cdsExplainInfo, cdsPlaceInfo;
      cdsExplainInfo = _.find(cdsExplain, {
        efctVal: sessionUserInfo.cfntDscMdCd,
      });
      if (!_.isEmpty(cdsExplainInfo)) {
        variables.cfntDscMd = cdsExplainInfo.efctValNm;
      }

      if (sessionUserInfo.cfntDscPlcCd == "9") {
        variables.cfntDscPlc = sessionUserInfo.cfntDscEtcPlc;
      } else {
        cdsPlaceInfo = _.find(cdsPlace, {
          efctVal: sessionUserInfo.cfntDscPlcCd,
        });
        if (!_.isEmpty(cdsPlaceInfo)) {
          variables.cfntDscPlc = cdsPlaceInfo.efctValNm;
        }
      }

      cdsExplainInfo = _.find(cdsExplain, {
        efctVal: sessionUserInfo.inspeCfntDscMdCd,
      });
      if (!_.isEmpty(cdsExplainInfo)) {
        variables.inspeCfntDscMd = cdsExplainInfo.efctValNm;
      }

      if (sessionUserInfo.inspeCfntDscPlcCd == "9") {
        variables.inspeCfntDscPlc = sessionUserInfo.inspeCfntDscEtcPlc;
      } else {
        cdsPlaceInfo = _.find(cdsPlace, {
          efctVal: sessionUserInfo.inspeCfntDscPlcCd,
        });
        if (!_.isEmpty(cdsPlaceInfo)) {
          variables.inspeCfntDscPlc = cdsPlaceInfo.efctValNm;
        }
      }

      // 계약 상세 조회
      axios.json("/getCtrInq.do", {}).then((result) => {
        util.saveLog("009", "계약기본사항"); // 009 : 화면진입
        let data = result.data;
        if (!util.isNull(data.ctrBasInfCoVo)) {
          state.ctrBasInfCoVo = data.ctrBasInfCoVo[0]; //계약정보
          state.ctrBasInfCoVo.petNm = result.data.patNm;
          let sbcpChnDivCd = state.ctrBasInfCoVo.sbcpChnDivCd;

          state.dporInclYn = sessionUserInfo.dporInclYn;

          let polhdNo = "";
          let age = "";
          state.dporInclYn = sessionUserInfo.dporInclYn
          _.forEach(data.ctrPtyCoVoLst, function(item, idx){
            if(item.ctrPtyRlCd == "01"){
                polhdNo = item.cusNo;
            }
          });

          _.forEach(data.inspePtyCoVoLst, function(item, idx){
              if(item.ctrPtyRlCd == "02"){
                age = item.age;
              }
              if(item.ctrPtyRlCd == '77' && polhdNo == item.cusNo){
                  if(age >= 15 && age <= 18 ){
                    state.papeYn = false;
                  }
              }
          })
          if (sbcpChnDivCd == "01") {
            router.push({ name: "cfntChnChngPrctr" });
            return false;
          }

          store.commit("elcSgnInf/clearImageData");
          store.commit("elcSgnInf/changeCfntInf", {
            cfntDscMd: variables.cfntDscMd,
            cfntDscPlc: variables.cfntDscPlc,
            inspeCfntDscMd: variables.inspeCfntDscMd,
            inspeCfntDscPlc: variables.inspeCfntDscPlc,
          });
        } else {
          if (!util.isNull(data.msg)) {
            dialog.alert(data.msg.standMsg).then(function () {
              router.push({ name: "cellAth" });
            });
          } else {
            dialog
              .alert(
                "시스템 오류로 계약조회가 실패하였습니다. 처음 본인인증 페이지로 돌아갑니다.."
              )
              .then(function () {
                router.push({ name: "cellAth" });
              });
          }
        }
      });
    });

    async function retrieveDmnInf(DmnCode) {
      var param = {};
      param.dmnVal = DmnCode;
      return await axios.json("/retrieveDmnInf.do", param);
    }

    const confirm = () => {
      let param = {
        orgCd: sessionUserInfo.orgCd,
        prctrNo: sessionUserInfo.prctrNo,
      };

      axios
        .json("/inspe/retrieveMblElcSgnTh3peDporDivInq.do", param)
        .then((res) => {
          store.commit(
            "elcSgnInf/changeMaInspeAge",
            state.ctrBasInfCoVo.maInspeAge
          );
          store.commit(
            "elcSgnInf/changeElcSgnTrgCoVo",
            res.data.elcSgnTrgCoVoLst
          );

          // 예 == 피인지 검사용
          let inspeTrgCoVo = _.filter(
            res.data.elcSgnTrgCoVoLst,
            (data) => data.ptyRlCd.indexOf("02") >= 0
          )[0];

          //예금주 당사자 존재여부 확인
          if (inspeTrgCoVo.ptyRlCd.indexOf("71") >= 0) {
            router.push({ name: "acntInfInp" });
          } else {
            router.push({ name: "sbcpDocSgn" });
          }
        });
    };

    return {
      state,
      confirm,
    };
  },
  methods: {
    dateFormat(date) {
      if (util.isEmpty(date)) return "";
      return util.formatDate(date, "yyyy-mm-dd");
    },
    numberFormat(number) {
      if (!number) {
        return 0;
      } else {
        return util.addCommas(number + "");
      }
    },
  },
};
</script>
